import React from 'react';
import RepeatElement from "@Generic/utility/RepeatElement";
import RoutePlaceholder from "@SearchResults/components/Placeholders/RoutePlaceholder";

function ReviewPlaceholder() {
    return (
        <RepeatElement numTimes={10}>
            <RoutePlaceholder placeholderClass="gb--card gb--review-snippet gb--review-card"/>
        </RepeatElement>
    );
}

export default ReviewPlaceholder;